import { render } from "./DialogUser.vue?vue&type=template&id=35e49fdc"
import script from "./DialogUser.vue?vue&type=script&lang=js"
export * from "./DialogUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__